export default __webpack_public_path__ + "static/16-bc938e2dfc1b2ce59b780ea7f165ad4d.jpg";